import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>December Wine Dinner</h1>
                <h2 className={classes.bold}>
                  December 3rd <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $75 Per Guest
                </h2>
                <h3>Hosted by International Wines <span className={classes.sp3}>&nbsp;&middot;&nbsp;</span>Featuring Mollydooker Wines</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>

          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>
                <h5>First Course</h5>
                <h4>ROASTED BEET SALAD</h4>
                <p>Endive Lettuce, Roasted Red Peppers, Pickled Red Onions, Carrots with Crumbled Gorgonzola, and Tarragon Vinaigrette</p>
                <p className={classes.pair}>Paired With</p>
                <h4>THE BOXER · SHIRAZ · AU '22</h4>
              </div>
 
              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>GINGER GLAZED RAINBOW TROUT</h4>
                <p>Wild Rice, Grilled Zucchini, and Orange Butter Sauce</p>
                <p className={classes.pair}>Paired With</p>
                <h4>THE MAITRE D' · CABERNET SAUVIGNON · AU '22</h4>
              </div>
              
              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>TRADITIONAL VENISON GOULASH</h4>
                <p>Stewed Venison Tenderloin in Tomato Sauce, Over Egg Noodles</p>
                <p className={classes.pair}>Paired With</p>
                <h4>THE SCOOTER · MERLOT · AU '21</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>RASPBERRY LAMINGTON</h4>
                <p>Vanilla Sponge Cake Coated In Chocolate and Desiccated Coconut</p>
                <p className={classes.pair}>Paired With</p>
                <h4>TWO LEFT FEET · SHIRAZ/CABERNET/MERLOT · AU '22</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner